import {
  Group,
  Image,
  ScrollArea,
  Stack,
  Text,
  UnstyledButton,
} from "@mantine/core";
import {
  IconDashboard,
  IconLogout,
  IconUserCheck,
  IconUsers,
} from "@tabler/icons-react";
import { signOut } from "aws-amplify/auth";
import { useLocation } from "wouter";
import { useUser } from "@/UserContext";
import { AdminRoutes } from "../routers/routes";
import classes from "./AdminSideNav.module.css";

interface NavLink {
  link: string;
  label: string;
  icon: React.ComponentType<{
    size?: string | number;
    stroke?: number;
    className?: string;
  }>;
}

const mockdata: NavLink[] = [
  { icon: IconDashboard, label: "Dashboard", link: AdminRoutes.DASHBOARD },
  { icon: IconUsers, label: "Trainers", link: AdminRoutes.TRAINERS },
  { icon: IconUserCheck, label: "Owners", link: AdminRoutes.OWNERS },
];

export const AdminSideNav = () => {
  const userInfo = useUser();
  const [location, navigate] = useLocation();
  const active = location;

  const handleSignOut = async () => {
    await signOut({ global: true });
  };

  const getDisplayName = (): string => {
    if (userInfo.token.given_name && userInfo.token.family_name) {
      return `${userInfo.token.given_name} ${userInfo.token.family_name}`.trim();
    }
    return String(userInfo.token.email || "");
  };

  const links = mockdata.map((item) => (
    <UnstyledButton
      className={classes.link}
      data-active={item.link === active || undefined}
      key={item.label}
      onClick={() => {
        navigate(item.link);
      }}
    >
      <item.icon className={classes.linkIcon} stroke={1.5} />
      <span>{item.label}</span>
    </UnstyledButton>
  ));

  return (
    <nav className={classes.navbar}>
      <div className={classes.navbarMain}>
        <Group className={classes.header}>
          <Group
            align="center"
            gap="xs"
            style={{
              flexWrap: "nowrap",
            }}
          >
            <Image
              radius="sm"
              src="/favicons/favicon-96x96.png"
              alt="🐾"
              width={36}
              height={36}
            />
            <Text
              size="xl"
              fw={700}
              c="black"
              style={{ display: "inline-block" }}
            >
              Woofapy
            </Text>
          </Group>{" "}
        </Group>
        <ScrollArea className={classes.links}>
          <div className={classes.linksInner}>{links}</div>
        </ScrollArea>
      </div>

      <div className={classes.footer}>
        <Stack gap="xs">
          <Text size="sm" c="dimmed" ta="center">
            {getDisplayName()}
          </Text>
          <UnstyledButton className={classes.link} onClick={handleSignOut}>
            <IconLogout className={classes.linkIcon} stroke={1.5} />
            <span>Sign Out</span>
          </UnstyledButton>
        </Stack>
      </div>
    </nav>
  );
};
